<template>
  <div>
    <!-- 新增人工报价规则 -->
    <el-dialog :title="
      $parent.isAdd
        ? $t('message.addedManualQuotationRules')
        : $t('message.editdManualQuotationRules')
    " :close-on-click-modal="false" :visible.sync="$parent.artificialDialogVisible" width="500px" center>
      <div class="box">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
          <!-- 发送方式名称： -->
          <!-- <el-form-item :label="$t('message.sendingModeName')" prop="name">
            {{ $parent.detail.name }}
          </el-form-item> -->
          <!-- 生效开始时间 -->

          <el-form-item :label="$t('message.effectiveStartTime')" prop="start_at">
            <el-date-picker v-model="ruleForm.start_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('message.startDate')">
            </el-date-picker>
          </el-form-item>
          <!-- 生效结束时间 -->
          <el-form-item :label="$t('message.validityEndTime')" prop="end_at">
            <el-date-picker v-model="ruleForm.end_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="$t('message.dateClosed')" :default-time="'23:59:59'">
            </el-date-picker>
          </el-form-item>
          <!-- 自动签收天数 -->
          <el-form-item :label="$t('message.daysOfAutomaticReceipt')" prop="sign_receive_days">
            <el-input v-model="ruleForm.sign_receive_days" placeholder="请输入业务发货后自动签收的天数"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.artificialDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 新增 -->
        <el-button type="primary" @click="logisticsAddRuleConfig" v-if="$parent.isAdd">{{ $t("message.save")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="logisticsUpdateRuleConfig" v-else>{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    ruleForm: { type: Object },
  },
  data() {
    return {
      rules: {
        start_at: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        end_at: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
        sign_receive_days: [
          {
            required: true,
            message: this.$t("message.TheRequired"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 新增人工计算
    logisticsAddRuleConfig() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration
            .logisticsAddRuleConfig(this.ruleForm)
            .then((res) => {
              this.$message.success(res.msg);
              this.$parent.artificialDialogVisible = false;
              this.$parent.logisticsDetail();
            });
        }
      });
    },
    // 修改人工计算
    logisticsUpdateRuleConfig() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration
            .logisticsUpdateRuleConfig(this.ruleForm)
            .then((res) => {
              this.$message.success(res.msg);
              this.$parent.artificialDialogVisible = false;
              this.$parent.logisticsDetail();
            });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.box {
  padding: 24px;

  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  /deep/.el-date-editor {
    width: 100%;
  }
}
</style>